import React from "react"
import { createRoot } from "react-dom/client"
import Wizard from "./components/Wizard"
import type { WizardArchetype } from "./types"

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("wizard-root")
  if (!container) return

  let archetypes: WizardArchetype[] = []
  try {
    archetypes = JSON.parse(container.dataset.archetypes || "[]")
  } catch {
    archetypes = []
  }

  createRoot(container).render(
    <Wizard archetypes={archetypes} preselected={container.dataset.preselected || null} />
  )
})
